import { getPlatform } from '../platform';
import {
  getAskSessionChoice,
  getBluetoothProviderPreference,
  type BluetoothProviderPreference,
} from './bluetoothProviderSettings';
import { isPayzheBtpEligible } from './mobilePlatform';

export type ResolvedBluetoothRoute = 'native' | 'browser';

export function shouldUsePayzheBtpNative(preference?: BluetoothProviderPreference): boolean {
  const pref = preference ?? getBluetoothProviderPreference();

  if (pref === 'browser-always') return false;
  if (!isPayzheBtpEligible()) return false;

  if (pref === 'payzhe-btp') return true;
  if (pref === 'browser-fallback') return true;

  if (pref === 'ask') {
    const session = getAskSessionChoice();
    if (session === 'browser-always') return false;
    if (session === 'payzhe-btp' || session === 'browser-fallback') return true;
    return true;
  }

  return false;
}

export function shouldFallbackToBrowserOnNativeFailure(
  preference?: BluetoothProviderPreference,
): boolean {
  const pref = preference ?? getBluetoothProviderPreference();
  if (pref === 'browser-fallback') return true;
  if (pref === 'ask') {
    const session = getAskSessionChoice();
    return session === 'browser-fallback';
  }
  return false;
}

export function resolveInitialRoute(preference?: BluetoothProviderPreference): ResolvedBluetoothRoute {
  return shouldUsePayzheBtpNative(preference) ? 'native' : 'browser';
}

export function getPlatformLabel(): string {
  return getPlatform();
}
